import script from "./TagCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./TagCellElementLite.vue?vue&type=style&index=0&id=6f868c30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f868c30"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
